import SectionTitle from '../ui/section-title'

import UserFeedCardSkeleton from './user-feed-card-skeleton'

const UserFeedListSkeleton = () => {
  return (
    <section>
      <SectionTitle title="Activity" />
      <div className="mt-4 flex flex-row flex-wrap gap-4">
        {[1, 2, 3].map((i) => (
          <UserFeedCardSkeleton key={i} />
        ))}
      </div>
    </section>
  )
}

export default UserFeedListSkeleton
